<ng-container *transloco="let t; prefix: scope">
  <rma-compare-tray
    [tiles]="facade.tiles()"
    [heading]="t('tray.heading', { count: facade.tiles().length })"
    [compareLabel]="t('tray.compare')"
    [clearLabel]="t('tray.clear-all')"
    [removeLabel]="t('tray.remove')"
    [scrollLabel]="t('tray.scroll')"
    (remove)="facade.remove($event)"
    (clear)="facade.clear()"
    (compare)="compare.emit()"
  />
</ng-container>
